import React from "react";
import {
  Modal,
  Descriptions,
  Tag,
  Avatar,
  Typography,
  Divider,
  Button,
  Tooltip,
} from "antd";
import {
  UserOutlined,
  CalendarOutlined,
  TagOutlined,
  PhoneOutlined,
  CheckOutlined,
  MailOutlined,
  MessageOutlined,
  GlobalOutlined,
  CodeOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { transformString } from "../../helpers/channelNameTransformation";
import { formatDateTime } from "../../utils/formatDateTime";

const { Title, Text } = Typography;

const CtaDetailsDialog = ({
  visible,
  setCtaStatusDialogOpen,
  ctaData,
  onClose,
}) => {
  console.log("ctaData -> ", ctaData);

  if (!visible || !ctaData) return null;

  return (
    <Modal
      title={<Title level={4}>{transformString(ctaData?.name) || "N/A"}</Title>}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      style={{
        zIndex: "10000",
      }}
    >
      {ctaData ? (
        <div>
          <Descriptions
            bordered
            column={1}
            labelStyle={{ width: "30%", fontWeight: 500 }}
            contentStyle={{ width: "70%" }}
          >
            {
              ctaData.customer_name || ctaData.extra_info?.customer_name ? (
                <Descriptions.Item label="Customer Name">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <Avatar icon={<UserOutlined />} />
                    <Text strong>
                      {ctaData.customer_name || ctaData.extra_info?.customer_name || "N/A"}
                    </Text>
                  </div>
                </Descriptions.Item>
              ) : null
            }
            {
              ctaData.customer_phone_number || ctaData.extra_info?.contact_number ? (
                <Descriptions.Item label="Contact Number">
                  <Text>
                    <PhoneOutlined style={{ marginRight: "8px" }} />
                    {ctaData.customer_phone_number || ctaData.extra_info?.contact_number || "N/A"}
                  </Text>
                </Descriptions.Item>
              ) : null
            }
            {
              ctaData.customer_email || ctaData.extra_info?.email ? (
                <Descriptions.Item label="Email Address">
                  <Text>
                    <MailOutlined style={{ marginRight: "8px" }} />
                    {ctaData.customer_email || ctaData.extra_info?.email || "N/A"}
                  </Text>
                </Descriptions.Item>
              ) : null
            }
            {
              ctaData.extra_info["Address"] ? (
                <Descriptions.Item label="Address">
                  <Text
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>
                    <iconify-icon icon="lsicon:location-outline" width="18" height="18"></iconify-icon>
                    {ctaData.extra_info["Address"] || "N/A"}
                  </Text>
                </Descriptions.Item>
              ) : null
            }

            {/* <Descriptions.Item label="Contact Details">
              {ctaData?.channel === "Whatsapp" ? (
                <Text>
                  <PhoneOutlined style={{ marginRight: "8px" }} />
                  {ctaData.customer_phone_number || "N/A"}
                </Text>
              ) : (
                ctaData?.channel === "Website" && (
                  <Text>
                    <MailOutlined style={{ marginRight: "8px" }} />
                    {ctaData.customer_email || "N/A"}
                  </Text>
                )
              )}
            </Descriptions.Item> */}
            <Descriptions.Item label="Description">
              <span dangerouslySetInnerHTML={{ __html: (ctaData.description || "No description provided")
                .replace(/\n\n/g, '<hr style="border: none; border-top: 1px solid #ddd; margin: 10px 0;">')
                .replace(/\n/g, '<br>')
                .replace(/\((\d{4}-\d{2}-\d{2}:\d{2}:\d{2}:\d{2})\)/g, (match, dateStr) => {
                  const formattedDate = formatDateTime({ date: dateStr.replace(':', 'T'), withTime: true });
                  return '<b>(' + formattedDate + ')</b>';
                }) }} />
            </Descriptions.Item>
            <Descriptions.Item label="Channel">
              <Tag
                icon={
                  ctaData.channel === "Website" ? (
                    <GlobalOutlined />
                  ) : ctaData.channel === "Playground" ? (
                    <CodeOutlined />
                  ) : ctaData.channel ? (
                    <MessageOutlined />
                  ) : null
                }
              >
                {ctaData.channel || "N/A"}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Type">
              <Tag icon={<TagOutlined />}>
                {transformString(ctaData.type) || "N/A"}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Created At">
              <Text>
                <CalendarOutlined style={{ marginRight: "8px" }} />
                {formatDateTime({ date: ctaData.created_at, withTime: true, timeSeparator: " at" })}
              </Text>
            </Descriptions.Item>
            {ctaData.updated_at && ctaData.updated_at !== ctaData.created_at && (
              <Descriptions.Item label="Updated At">
                <Text>
                  <CalendarOutlined style={{ marginRight: "8px" }} />
                  {formatDateTime({ date: ctaData.updated_at, withTime: true, timeSeparator: " at" })}
                </Text>
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Status">
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tag
                  color={
                    ctaData.status === "open"
                      ? "blue"
                      : ctaData.status === "resolved"
                      ? "green"
                      : ctaData.status === "in_progress"
                      ? "orange"
                      : "default"
                  }
                >
                  {ctaData.status?.toUpperCase() || "N/A"}
                </Tag>

                {ctaData.status === "open" && (
                  <Tooltip title="Resolve this CTA" placement="top">
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => {
                        setCtaStatusDialogOpen(true);
                        // close the details dialog
                        onClose();
                      }}
                      tooltip="Resolve this CTA"
                      style={{
                        marginLeft: "8px",
                        backgroundColor: "#3D90D7",
                        height: "22px",
                      }}
                    >
                      Resolve This CTA
                    </Button>
                  </Tooltip>
                )}
              </div>
            </Descriptions.Item>
            {ctaData.status === "resolved" && (
              <>
                <Descriptions.Item label="Resolved At">
                  <Text>
                    <CalendarOutlined style={{ marginRight: "4px" }} />
                    {formatDateTime({ date: ctaData.resolved_at, withTime: true, timeSeparator: " at" })}
                  </Text>
                </Descriptions.Item>
                <Descriptions.Item label="Resolved By">
                  <Text>{ctaData.resolved_by || "N/A"}</Text>
                </Descriptions.Item>
              </>
            )}
          </Descriptions>
          {ctaData.status === "resolved" && (
            <>
              <Divider />
              <div style={{ marginTop: "16px" }}>
                <Title level={5}>Resolution Details</Title>
                <Text type="secondary">
                  {ctaData.remarks || "No remarks provided."}
                </Text>
              </div>
            </>
          )}
        </div>
      ) : (
        <Text>No data available.</Text>
      )}
    </Modal>
  );
};

export default CtaDetailsDialog;
